import { MultiPolygon } from "geojson";

import { IGeoAreaGeom, IGeoJSON, IGeoJsonPolygonGeometry } from "../models";

export const convertGeoAreasGeomToGeoJson = (
  geoAreasGeom: IGeoAreaGeom[],
): IGeoJSON => {
  return {
    type: "FeatureCollection",
    features: geoAreasGeom.flatMap(item => {
      return item.geom.coordinates.map(cords => {
        return {
          type: "Feature",
          properties: {},
          geometry: {
            type: "Polygon",
            coordinates: cords as IGeoJsonPolygonGeometry["coordinates"],
          },
        };
      });
    }),
  };
};

export const convertMultiPolygonsToGeoJSON = (
  multiPolygon?: MultiPolygon,
): IGeoJSON => {
  if (!multiPolygon) {
    return {
      type: "FeatureCollection",
      features: [],
    };
  }

  return {
    type: "FeatureCollection",
    features: multiPolygon.coordinates.map(cords => ({
      type: "Feature",
      properties: {},
      geometry: {
        type: "Polygon",
        coordinates: cords as IGeoJsonPolygonGeometry["coordinates"],
      },
    })),
  };
};

export const convertGeoJSONToMultiPolygons = (
  geoJson: IGeoJSON,
): MultiPolygon => {
  return {
    type: "MultiPolygon",
    coordinates: geoJson.features.map(
      feature => feature.geometry.coordinates,
    ) as MultiPolygon["coordinates"],
  };
};
